/* ---- promo popup ---- */
class PromoPopup extends HTMLElement {
  constructor() {
    super();
    this.testMode = this.dataset.testMode === "true";
    this.secondsDelay = this.dataset.delaySeconds;
    this.daysFrequency = this.dataset.delayDays;
    this.modal = this.querySelector(".sign-up-popup-modal");
    this.timer = this.querySelector(".popup-modal__timer");
    this.timerDuration = this.dataset.timerDuration;
    this.closeBtns = this.querySelectorAll(".promp-popup__close-btn");
    this.overlay = document.querySelector(".sign-up-popup-overlay");
    this.storageKey = "promo-bar-data-" + window.location.host;
    if (this.testMode) {
      if (this.timer) {
        this.displayPromoTimer();
      }
    } else if (localStorage.getItem(this.storageKey) === null) {
      this.openPopupModal();
    } else {
      let t = JSON.parse(localStorage.getItem(this.storageKey));
      let x = new Date(t.next_display_date);
      if (currentDate.getTime() > x.getTime()) {
        this.openPopupModal();
      }
    }
    this.closeBtns.forEach(t => {
      t.addEventListener("click", this.closeModal.bind(this));
    });
  }
  openPopupModal() {
    setTimeout(() => {
      this.modal.classList.add("popup-modal--active");
      this.overlay.classList.add("popup-overlay--active");
      let t = addDays(currentDate, parseInt(this.daysFrequency));
      localStorage.setItem(this.storageKey, JSON.stringify({
        next_display_date: t,
        dismissed: false
      }));
      if (this.timer) {
        this.displayPromoTimer();
      }
    }, parseInt(this.secondsDelay) * 1000 + 3000);
  }
  displayPromoTimer() {
    this.minutesSpan = this.querySelector(".popup-modal__timer__minutes");
    this.secondsSpan = this.querySelector(".popup-modal__timer__seconds");
    this.totalSeconds = parseFloat(this.timerDuration) * 60;
    this.updateTimer();
    setInterval(() => {
      this.totalSeconds -= 1;
      this.updateTimer();
      if (this.totalSeconds <= 0) {
        this.totalSeconds = parseFloat(this.timerDuration) * 60 - 45;
      }
    }, 1000);
  }
  updateTimer() {
    let t = Math.floor(this.totalSeconds / 60);
    if (t.toString().length === 1) {
      t = "0" + t;
    }
    let x = this.totalSeconds % 60;
    if (x.toString().length === 1) {
      x = "0" + x;
    }
    this.minutesSpan.innerText = t;
    this.secondsSpan.innerText = x;
  }
  closeModal() {
    this.modal.classList.remove("popup-modal--active");
    this.overlay.classList.remove("popup-overlay--active");
  }
}
customElements.define("promo-popup", PromoPopup);

/* ---- popup copy button ---- */
class PopupCopyButton extends CopyButton {
  constructor() {
    (super(),
      (this.copySuccessMsg = document.querySelector(
        ".popup-modal__success-msg",
      )));
  }
  handleClick(t) {
    (this.textarea.select(),
      document.execCommand("copy"),
      (this.copySuccessMsg.style.display = "block"));
  }
}
customElements.define("popup-copy-button", PopupCopyButton);
